import { LocationDescriptor } from 'history';
import { BtnLayout, BtnType } from 'mk2/components/Btn';
import { goBackInPWA } from 'mk2/services/browserHistory';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import Btn from './Btn';

interface OwnProps {
    className?: string;
    icon?: string;
    asAnchor?: boolean;
    link: LocationDescriptor;
    layout?: BtnLayout;
    type?: BtnType;
    label?: React.ReactNode;
}

type RouteProps = RouteComponentProps<{}>;

type Props = OwnProps & RouteProps;

class BackBtn extends React.PureComponent<Props> {
    public static defaultProps: Partial<Props> = {
        layout: BtnLayout.Icon,
    };

    public render() {
        const { className, icon, link, asAnchor, layout, label, type } = this.props;

        return (
            <Btn
                layout={layout}
                icon={icon}
                className={className}
                link={link}
                asAnchor={asAnchor}
                onClick={!asAnchor ? this.onClick : undefined}
                label={label}
                type={type}
            />
        );
    }

    private onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const { link, history } = this.props;

        event.preventDefault();
        event.stopPropagation();

        goBackInPWA(history, link);
    };
}

export default withRouter(BackBtn);
